import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import PhoneInput from "react-phone-input-2";
import dayjs from "dayjs";
import { formatText, normalizeDateToLocal } from "../../../../utils";
import { frequencyData, paymentMethodsData } from "../../../../data";
import { useWatch } from "antd/es/form/Form";

const { TextArea } = Input;
const AddStandingModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { subwalletData, banks } = useSelector((state) => state.fetch);

  const urlCat = "api/v1/payments/fetch-payment-categories";
  const urlSubCat = "api/v1/payments/fetch-sub-categories";

  const { loading, dataCat, dataSubCat } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataCat: state.fetch.data[urlCat] || [],
    dataSubCat: state.fetch.data[urlSubCat] || [],
  }));

  const { saving } = useSelector((state) => state.save);
  const [categoryName, setCategoryName] = useState();

  async function fetchSubCategoryData(value) {
    dispatch(
      fetchData({
        url: urlSubCat,
        pcId: value,
      })
    );
  }
  const onFinish = async (data) => {
    data.soId = prodd.soId ?? null;
    data.soStartDate = normalizeDateToLocal(data?.soStartDate);
    data.soEndDate = normalizeDateToLocal(data?.soEndDate);
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/payments/save-standing-order",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
        soStartDate: prodd?.soStartDate
          ? dayjs(new Date(prodd?.soStartDate))
          : null,
        soEndDate: prodd?.soEndDate ? dayjs(new Date(prodd?.soEndDate)) : null,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  const soPaymentType = useWatch("soPaymentType", form);
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.soName}` : "Add Standing Order Details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid lg:grid-cols-2 lg:gap-x-5 grid-cols-1">
            <Form.Item
              name="soName"
              className=""
              label={<span>Subscription Name</span>}
              rules={[
                {
                  required: false,
                  message: "Please add subscription name",
                },
              ]}
            >
              <Input className="input" />
            </Form.Item>

            <Form.Item
              name="soPaymentType"
              className=""
              label={<span>Payment Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please select payment type",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  paymentMethodsData?.length > 0 &&
                  paymentMethodsData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
              />
            </Form.Item>
            {soPaymentType === "BANK" ? (
              <>
                <Form.Item
                  name="soBeneficiaryBank"
                  className=""
                  label={<span>Bank</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please select payment bank",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      banks?.length > 0 &&
                      banks?.map((item) => ({
                        value: item?.bnkNo,
                        label: item?.bnkName,
                      }))
                    }
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                    onDropdownVisibleChange={() => {}}
                  />
                </Form.Item>
                <Form.Item
                  name="soBeneficiaryAccount"
                  label="Account Number"
                  rules={[
                    {
                      required: true,
                      message: "Enter account number",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                    placeholder="Enter account"
                    className="input flex"
                  />
                </Form.Item>
              </>
            ) : soPaymentType === "MOBILE_MONEY" ? (
              <Form.Item
                name="soReceiverMobileNo"
                label="Receiver Number"
                rules={[
                  {
                    required: true,
                    message: "Please add Receiver Number",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.length === 12) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Phone number must be exactly 10 characters")
                      );
                    },
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  countryCodeEditable={false}
                  className="input"
                />
              </Form.Item>
            ) : null}

            <Form.Item
              name="soWalId"
              className=""
              label={<span>Payment Source</span>}
              rules={[
                {
                  required: true,
                  message: "Please select payment source",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  subwalletData?.length > 0 &&
                  subwalletData?.map((item) => ({
                    value: item?.walId,
                    label:
                      item?.walName +
                      " - " +
                      item?.walCode +
                      " - " +
                      item?.walCurrency +
                      " " +
                      item?.walAvailableBalance,
                  }))
                }
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
            </Form.Item>

            <Form.Item
              name="soPcId"
              className=""
              label={<span>Category</span>}
              rules={[
                {
                  required: false,
                  message: "Please select payment category",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  dataCat?.length > 0 &&
                  dataCat?.map((item) => ({
                    value: item?.pcId,
                    label: item?.pcName,
                  }))
                }
                onChange={(value) => {
                  fetchSubCategoryData(value);
                  const selectedItem = dataCat?.find(
                    (item) => item?.pcId === value
                  );
                  setCategoryName(selectedItem?.pcName || "");
                  form.resetFields(["soPscId"]);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            {categoryName && (
              <Form.Item
                name="soPscId"
                className=""
                label={<span>Sub Category</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select payment sub-category",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataSubCat?.length > 0 &&
                    dataSubCat?.map((item) => ({
                      value: item?.pscId,
                      label: item?.pscName,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
            )}

            <Form.Item
              name="soAmount"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Enter amount",
                },
              ]}
            >
              <InputNumber
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                placeholder="Enter amount"
                className="input flex"
              />
            </Form.Item>

            <Form.Item
              name="soNationalId"
              label="National ID"
              rules={[
                {
                  required: false,
                  message: "Recepient National ID is required",
                },
                {
                  validator(_, value) {
                    if (value && value.toString().length < 6) {
                      return Promise.reject(
                        "National ID must be at least 6 characters long"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber
                min={0}
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                className="input flex"
              />
            </Form.Item>

            <Form.Item
              name="soFrequency"
              className=""
              label={<span>Recurring</span>}
              rules={[
                {
                  required: false,
                  message: "Please select recurring frequency",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  frequencyData?.length > 0 &&
                  frequencyData?.map((item) => ({
                    value: item?.value,
                    label: formatText(item?.label),
                  }))
                }
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
            </Form.Item>

            <Form.Item
              name="soStartDate"
              label="Start Date"
              rules={[
                {
                  required: false,
                  message: "Field is required",
                },
              ]}
            >
              <DatePicker
                format="DD MMM YYYY"
                className="input"
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
                onChange={(value) => {
                  form.resetFields(["soPscId"]);
                  const endDate = form.getFieldValue("soEndDate");
                  if (endDate && value && endDate < value) {
                    form.resetFields(["soEndDate"]);
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              name="soEndDate"
              label="End Date"
              rules={[
                {
                  required: false,
                  message: "Field is required",
                },
              ]}
            >
              <DatePicker
                format="DD MMM YYYY"
                className="input"
                disabledDate={(current) => {
                  const startDate = form.getFieldValue("soStartDate");
                  if (current && current < dayjs().startOf("day")) {
                    return true;
                  }

                  if (
                    startDate &&
                    current &&
                    current < startDate.startOf("day")
                  ) {
                    return true;
                  }

                  return false;
                }}
              />
            </Form.Item>
          </div>

          <Form.Item
            name="soReason"
            label="Reason for transfer"
            rules={[
              {
                required: true,
                message: "Enter reason for transfer",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Enter reason for transfer"
              className="input-textarea"
            />
          </Form.Item>
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                  disabled={saving}
                >
                  {saving ? <Spin /> : prodd?.soId ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddStandingModal;
